// lib
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ADND from '@aytm/lib/adnd/ADND'
import Popup, { PopupCloseButton } from '@aytm/lib/rfd-ui/components/basic/popup'
import uploadAsset from '@aytm/app/stats/page/assets/jobs/AssetUploadManager'

// styles
import '@aytm/app/stats/page/styles/globals.scss'

import style from '@aytm/app/stats/page/assets/styles/index.module.scss'

export default class AssetFileUploader extends Component {
  static propTypes = {
    text: PropTypes.string,
    type: PropTypes.string,
    contentType: PropTypes.string,
    uploadUrl: PropTypes.string,
    statusUrl: PropTypes.string,
    upgradePackage: PropTypes.object,
    disabled: PropTypes.bool,
    getAccessKey: PropTypes.func,
    onFileUploaded: PropTypes.func,
    onFileError: PropTypes.func,
    onClosePopup: PropTypes.func
  }

  constructor(...args) {
    super(...args)
    this.connectDropTarget = this.connectDropTarget.bind(this)
    this.onAssetFileDragEnter = this.onAssetFileDragEnter.bind(this)
    this.onAssetFileDragLeave = this.onAssetFileDragLeave.bind(this)
    this.acceptAssetFileDrop = this.acceptAssetFileDrop.bind(this)
    this.onAssetFileDrop = this.onAssetFileDrop.bind(this)
    this.inputFileSelected = this.inputFileSelected.bind(this)
    this.onUploadFailed = this.onUploadFailed.bind(this)
    this.onUploadSuccess = this.onUploadSuccess.bind(this)
    this.onDropFile = this.onDropFile.bind(this)
    this.closePopup = this.closePopup.bind(this)
    this.renderActiveState = this.renderActiveState.bind(this)
    this.renderDisabledState = this.renderDisabledState.bind(this)

    this.dropAssetFileTarget = ADND.targets
      .files()
      .onDrop(this.onAssetFileDrop)
      .onEnter(this.onAssetFileDragEnter)
      .onLeave(this.onAssetFileDragLeave)
      .acceptDrop(this.acceptAssetFileDrop)
  }

  state = {
    dragOver: false,
    acceptFile: true,
    uploading: false,
    processing: false,
    progress: null,
    warnings: [],
    errors: []
  }

  inputRef = React.createRef()

  connectDropTarget(ref) {
    this.dropAssetFileTarget.connect(ref)
  }

  onAssetFileDragEnter() {
    this.setState(state => {
      return {
        ...state,
        dragOver: true
      }
    })
  }

  onAssetFileDragLeave() {
    this.setState(state => {
      return {
        ...state,
        dragOver: false
      }
    })
  }

  acceptAssetFileDrop() {
    const { acceptFile = true } = this.state
    return acceptFile
  }

  onAssetFileDrop(...files) {
    0 < files.length && this.onDropFile(files[0])
  }

  inputFileSelected() {
    if (this.inputRef.current && this.inputRef.current.files && 0 < this.inputRef.current.files.length) {
      this.onDropFile(this.inputRef.current.files[0])
    }
  }

  onUploadFailed(error) {
    if (!this.mounted) return

    const { onFileError } = this.props
    const errors = error.errors && 0 < error.errors.length ? error.errors : ["We couldn't process your file"]
    const warnings = error.warnings || []
    this.setState(
      state => {
        return {
          ...state,
          acceptFile: true,
          uploading: false,
          processing: false,
          progress: null,
          errors,
          warnings
        }
      },
      () => {
        'function' == typeof onFileError && onFileError(errors)
      }
    )
  }

  onUploadSuccess({ asset, result }) {
    if (!this.mounted) return

    const { onFileUploaded } = this.props
    const warnings = (result && result.warnings) || []

    this.setState(
      state => {
        return {
          ...state,
          warnings
        }
      },
      () => {
        onFileUploaded(asset, warnings)
          .then(() => {
            if (this.mounted) {
              this.setState(state => {
                return {
                  ...state,
                  acceptFile: true,
                  uploading: false,
                  processing: false,
                  progress: null
                }
              })
            }
          })
          .catch(this.onUploadFailed)
      }
    )
  }

  onDropFile(file) {
    const { uploadUrl, statusUrl, contentType, getAccessKey, onFileUploaded } = this.props
    const { acceptFile = true } = this.state

    if (!acceptFile) return

    this.closePopup()

    if ('function' == typeof getAccessKey && 'function' == typeof onFileUploaded) {
      this.setState(
        state => {
          return {
            ...state,
            dragOver: false,
            acceptFile: false,
            uploading: true
          }
        },
        () => {
          getAccessKey().then(accessKey => {
            uploadAsset(file, uploadUrl, statusUrl, contentType, accessKey, (progress, totalProgress) => {
              if (this.mounted) {
                const percents = (100 * progress) / totalProgress
                this.setState(state => {
                  return {
                    ...state,
                    uploading: 95 >= percents,
                    processing: 95 < percents,
                    progress: percents
                  }
                })
              }
            })
              .then(this.onUploadSuccess)
              .catch(this.onUploadFailed)
          })
        }
      )
    }
  }

  closePopup() {
    const { onClosePopup } = this.props
    this.setState(
      state => {
        return {
          ...state,
          warnings: [],
          errors: []
        }
      },
      () => {
        'function' == typeof onClosePopup && onClosePopup()
      }
    )
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
    this.dropAssetFileTarget.disconnect()
  }

  renderActiveState() {
    const { text, type } = this.props
    const { dragOver, acceptFile = true, uploading, processing, warnings, errors } = this.state

    return (
      <>
        {!uploading && !processing && (0 < warnings.length || 0 < errors.length) && (
          <Popup
            width="254px"
            direction="topleft"
            show
            content={() => (
              <>
                <PopupCloseButton onClose={this.closePopup}>
                  <i className="icon-aytmfd-close-v2" />
                </PopupCloseButton>
                <div dangerouslySetInnerHTML={{ __html: errors.concat(warnings).join('<br/><br/>') }}></div>
              </>
            )}
          >
            <span className={style['component-popup-anchor']}></span>
          </Popup>
        )}
        <div
          ref={this.connectDropTarget}
          className={classNames(style.button, {
            [style['button-active']]: dragOver
          })}
        >
          {acceptFile ? (
            <input
              ref={this.inputRef}
              className={style.input}
              type="file"
              name="file"
              accept={type || '*'}
              multiple={false}
              tabIndex="-1"
              onChange={this.inputFileSelected}
            />
          ) : null}
          {uploading || processing ? (
            <>
              <span className={style.icon}>
                <i className="icon-aytmfd-refresh-v2 aytmfd-spin" />
              </span>
              <span className={style.label}>{uploading ? 'Uploading...' : 'Processing...'}</span>
            </>
          ) : (
            <>
              <span className={style.icon}>
                <i className="icon-aytmfd-excel-v2" />
              </span>
              <span className={style.label} dangerouslySetInnerHTML={{ __html: text }}></span>
            </>
          )}
          <span className={style['upload-icon']}>
            <i className="icon-aytmfd-export-v2" />
          </span>
        </div>
      </>
    )
  }

  renderDisabledState() {
    const { text, upgradePackage = null } = this.props

    return null !== upgradePackage ? (
      <Popup
        targetClassName="p-field p-col-12"
        width="254px"
        trigger="hover"
        direction="topleft"
        content={() => (
          <div>
            <p>
              {/* PME2 (AYTM-11321): render server-authored `text` verbatim; guard the icon, which
                  the already-on-Enterprise Contact-Us variant omits. */}
              {upgradePackage.icon ? (
                <span className={`stat-upgrade-icon stat-upgrade-icon-${upgradePackage.id}`}>
                  <i className={`icon-aytmfd-${upgradePackage.icon}`} />
                </span>
              ) : null}
              <span dangerouslySetInnerHTML={{ __html: upgradePackage.text }} />
            </p>
          </div>
        )}
      >
        <a className={style.button} href={upgradePackage.upgradeURL} target="_blank" rel="noreferrer">
          <span className={style.icon}>
            <i className="icon-aytmfd-excel-v2" />
          </span>
          <span className={style.label} dangerouslySetInnerHTML={{ __html: text }}></span>
          <span className={style['lock-icon']}>
            <i className="icon-aytmfd-lock" />
          </span>
        </a>
      </Popup>
    ) : (
      <div className={style.button}>
        <span className={style.icon}>
          <i className="icon-aytmfd-excel-v2" />
        </span>
        <span className={style.label} dangerouslySetInnerHTML={{ __html: text }}></span>
        <span className={style['lock-icon']}>
          <i className="icon-aytmfd-lock" />
        </span>
      </div>
    )
  }

  render() {
    const { upgradePackage = null, disabled } = this.props
    const { acceptFile = true, warnings, errors } = this.state

    return (
      <div
        className={classNames(`${style.component} p-fluid`, {
          [style['component-note']]: 0 < warnings.length,
          [style['component-error']]: 0 < errors.length,
          [style['component-warning']]: null !== upgradePackage,
          [style['component-disabled']]: (disabled && null === upgradePackage) || !acceptFile
        })}
      >
        {disabled ? this.renderDisabledState() : this.renderActiveState()}
      </div>
    )
  }
}
